import React from 'react';
import { Divider } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
    separateBorder: {
        background: '#0B9FD9',
        height: '3px',        
        [theme.breakpoints.down('md')]: {
            display: 'none',
        },
    },
}));

const HorizontalDivider = () => {
    const classes = useStyles();
    return <Divider orientation="horizontal" classes={{ root: classes.separateBorder }} />;
};

export default HorizontalDivider;
